module.exports = __webpack_public_path__ + "static/media/capgemini_logo.170736e5.png";